<template>
	<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" append-to-body @close="dialogClose" top="5vh" width="1200px">
		<div class="flex justify-between">
			<div style="width: 380px;">
				<el-card :body-style="{ padding: 0, height: '600px', 'overflow-y': 'auto' }" shadow="never">
					<div slot="header" class="flex justify-between align-center">
						<div class="flex align-center">
							<span class="iconfont-bumen"></span>
							<span class="text-bold margin-left-sm">组织架构</span>
						</div>
					</div>
					<div style=" padding: 10px 10px 10px 0;">
						<el-tree
							ref="deptTree"
							:data="departmentTreeData"
							:expand-on-click-node="false"
							:props="{ label: 'name' }"
							:default-expand-all="true"
							:highlight-current="true"
							node-key="id"
							:current-node-key="departmentInfo.id"
							:default-checked-keys="[departmentInfo.id]"
							@node-click="handleNodeClick"
							:indent="0"
							class="tree-line tree-menu"
						>
							<span class="text-df" slot-scope="{ node, data }">
								<span>{{ data.name }}</span>
								<el-tag size="mini" type="info" class="margin-left-xs" v-if="data.stateflag == 0">已解散</el-tag>
							</span>
						</el-tree>
					</div>
				</el-card>
			</div>
			<div style="width: 100%;" class="margin-left">
				<el-card class="" :body-style="{ padding: 0 }" shadow="never">
					<div slot="header">
						<div class="flex justify-between align-center">
							<div class="title flex align-center">
								<span class="iconfont-yuangong"></span>
								<span class="text-bold margin-left-xs">{{ departmentInfo.name }}</span>
								<span class="padding-left-xs text-grey">[ {{ departmentInfo.id }} ]</span>
							</div>
							<div class="searchForm margin-left">
								<el-checkbox v-model="formSearch.data.has_leave" :true-label="1" :false-label="0" @change="get_infos_employee">包含已离职</el-checkbox>
								<el-checkbox v-model="formSearch.data.has_children" :true-label="1" :false-label="0" @change="get_infos_employee">包含子部门</el-checkbox>
							</div>
						</div>
					</div>
					<el-table
						:data="tableData_employee"
						style="width: 100%"
						:height="548"
						stripe
						tooltip-effect="dark"
						v-loading="loading"
						element-loading-text="加载中..."
						element-loading-spinner="el-icon-loading"
					>
						<el-table-column align="center" label="选择" width="100">
							<template slot-scope="scope">
								<el-checkbox :value="itemChecked.indexOf(scope.row.user_id) >= 0" @change="checkItem(scope.row)"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column align="left" label="姓名">
							<template slot-scope="scope">
								<span v-if="scope.row.gender == 1" class="text-blue text-bold">
									{{ scope.row.name }}
									<span class="el-icon-male"></span>
								</span>
								<span v-else-if="scope.row.gender == 2" class="text-pink text-bold">
									{{ scope.row.name }}
									<span class="el-icon-female"></span>
								</span>
								<span v-else class="text-black text-bold">{{ scope.row.name }}</span>
								<el-tag type="warning" effect="plain" size="mini" class="margin-left" v-if="scope.row.is_leader">主管</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="type" align="center" label="状态" width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.stateflag == 1" class="cu-tag line-green radius">在职</span>
								<span v-else-if="scope.row.stateflag == 0" class="cu-tag line-gray radius">离职</span>
								<span v-else class="cu-tag line-red radius">未知</span>
							</template>
						</el-table-column>
						<el-table-column prop="officeid" align="center" label="工号"></el-table-column>
						<el-table-column prop="position" align="center" label="职务"></el-table-column>
					</el-table>
					<div class="padding-sm text-right">
						<el-pagination
							background
							@size-change="pageSizeChange"
							@current-change="pageChange"
							:current-page="formSearch.page"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="formSearch.size"
							layout="total, sizes, prev, pager, next, jumper"
							:total="total"
							getCurrentKey="getCurrentKey"
						></el-pagination>
					</div>
				</el-card>
			</div>
		</div>
		<div class="margin-top border padding flex justify-between align-center" v-if="checkType == 'multiple'">
			<div class="flex align-center">
				<div class="text-blue text-bold text-center" style="width: 100px;">已选择：</div>
				<div>
					<el-tag type="info" size="small" disable-transitions closable @close="deleteItem(item.id)" v-for="item in employeeList" :key="item.id" class="margin-xs">
						<span>{{ item.name }}({{ item.officeid }})</span>
					</el-tag>
				</div>
			</div>
			<div><el-button type="primary" @click="dialogSubmit">确定</el-button></div>
		</div>
	</el-dialog>
</template>

<script>
import checkDepartmentSingle from '@/components/check-department-single.vue';
export default {
	components: { checkDepartmentSingle },
	name: 'check-employee',
	props: {
		show: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		max: {
			type: Number,
			default: () => {
				return 5;
			}
		},
		type: {
			type: String,
			default: () => {
				return 'single';
			}
		},
		dKey: {
			type: String,
			default: () => {
				return null;
			}
		},
		current: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	data() {
		return {
			dialogTitle: '选择人员',
			dialogVisible: false,
			loadingPage: false,
			departmentTreeData: null,
			departmentInfo: {},
			checkType: 'single',
			formSearch: {
				page: 1,
				size: 10,
				data: {}
			},
			total: 0,
			loading: false,
			tableData_employee: [],
			itemChecked: [],
			employeeList: [],
			dataKey: null
		};
	},
	beforecreate: function() {},
	created: function() {},
	mounted() {
		this.dialogVisible = this.show;
		this.maxCheck = this.max;
		if (this.checkType == 'multiple') {
			this.employeeList = Object.assign([], this.current);
		}
		this.checkType = this.type;
		this.dataKey = this.dKey;
		if (this.show) {
			this.init();
		}
	},
	updated: function() {},
	methods: {
		init() {
			if (!this.departmentTreeData) {
				this.getDepartmentTree();
			}
			if (this.checkType == 'multiple') {
				let itemChecked = [];
				let employeeList = [];
				if (this.employeeList.length > 0) {
					for (let i = 0; i < this.employeeList.length; i++) {
						if (itemChecked.indexOf(this.employeeList[i].id) < 0) {
							employeeList.push(this.employeeList[i]);
							itemChecked.push(this.employeeList[i].id);
						}
					}
				}
				this.employeeList = Object.assign([], employeeList);
				this.itemChecked = Object.assign([], itemChecked);
			} else {
				this.employeeList = this.itemChecked = [];
			}
		},
		getDepartmentTree() {
			if (!this.loading) {
				this.loading = true;
				this.$http.post('/server/index.php?m=components/checkEmployee&a=getDeptTreeList', {}).then(
					res => {
						this.loading = false;
						if (res.result == 'ok') {
							this.total = res.data.total;
							this.departmentTreeData = res.data.infos;
							this.handleNodeClick(res.data.infos[0]);
						} else {
							this.$alert(res.msg, {
								title: '操作错误',
								type: 'error'
							});
						}
					},
					r => {
						this.loading = false;
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				);
			}
		},
		handleNodeClick(e) {
			let departmentInfo = Object.assign({}, e);
			delete departmentInfo.children;
			this.departmentInfo = departmentInfo;
			this.formDeptModify = Object.assign({}, departmentInfo);
			this.formSearch.data.department_id = departmentInfo.id;
			this.get_infos_employee();
			this.$refs.deptTree.setCurrentKey(departmentInfo.id);
		},
		get_infos_employee() {
			this.loading = true;
			this.$http.post('/server/index.php?m=components/checkEmployee&a=getDeptEmpList', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.total = res.data.total;
						this.tableData_employee = res.data.infos;
						this.loading = false;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.get_infos_employee();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.get_infos_employee();
		},
		dialogClose() {
			this.$emit('close', false);
		},
		checkItem(val) {
			if (this.checkType == 'multiple') {
				let index = this.itemChecked.indexOf(val.user_id);
				if (index < 0) {
					this.itemChecked.push(val.user_id);
					this.employeeList.push({
						id: val.user_id,
						name: val.name,
						avatar: val.avatar,
						gender: val.gender,
						position: val.position,
						officeid: val.officeid,
						state: val.stateflag
					});
				} else {
					this.itemChecked.splice(index, 1);
					this.employeeList.splice(index, 1);
				}
			} else {
				this.$emit('change', {
					key: this.dataKey,
					data: { id: val.user_id, name: val.name, avatar: val.avatar, gender: val.gender, position: val.position, officeid: val.officeid, state: val.stateflag }
				});
				this.dialogClose();
			}
		},
		dialogSubmit() {
			this.$emit('change', { key: this.dataKey, data: this.employeeList });
			this.dialogClose();
		},
		deleteItem(id) {
			let index = this.itemChecked.indexOf(id);
			this.itemChecked.splice(index, 1);
			this.employeeList.splice(index, 1);
		}
	},
	watch: {
		show: function(val) {
			this.dialogVisible = val;
			if (val) {
				this.init();
			}
		},
		type: function(val) {
			this.checkType = val;
			this.init();
		},
		current: function(val) {
			if (typeof val == 'object' && this.checkType == 'multiple') {
				this.employeeList = Object.assign([], val);
			} else {
				this.employeeList = [];
			}
			this.init();
		},
		dKey: function(val) {
			this.dataKey = val;
			this.getDepartmentTree();
			this.init();
		}
	}
};
</script>

<style>
.el-dialog__body {
	padding-top: 0;
}
.tree-line .el-tree-node {
	position: relative;
	padding-left: 10px;
}
.tree-line .el-tree-node__children {
	padding-left: 10px;
}
.tree-line .el-tree-node::before {
	content: '';
	height: 100%;
	width: 1px;
	position: absolute;
	left: -3px;
	top: -26px;
	border-width: 1px;
	border-left: 1px dashed #ddd;
}
.tree-line .el-tree-node:last-child::before {
	height: 38px;
}
.tree-line .el-tree-node::after {
	content: '';
	width: 24px;
	height: 20px;
	position: absolute;
	left: -3px;
	top: 12px;
	border-width: 1px;
	border-top: 1px dashed #ddd;
}
.tree-line > .el-tree-node::after {
	border-top: none;
}
.tree-line > .el-tree-node::before {
	border-left: none;
}
.tree-line .el-tree-node__expand-icon {
	font-size: 10px;
}
.tree-line .el-tree-node__expand-icon.is-leaf {
	color: transparent;
}
.tree-menu.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	background-color: #515a6e;
	color: #fff;
}
</style>
